<template>
  <div class="content">
    <!-- <div class="breadcrumb">
      <i class="iconfont icondqwz"></i>
      <ul>
        <li>新闻管理</li>
        <li>在线学习</li>
        <li class="active">分类管理</li>
      </ul>
    </div> -->
    <el-tabs class="tabLv3" type="border-card" v-model="tabName">
      <i class="lt"></i>
      <i class="rt"></i>
      <el-tab-pane name="jsgl">
        <span slot="label">
          <i class="iconfont iconcheck"></i>
          <i class="border"></i>分类管理
        </span>
        <div class="normalNav">
          <div class="buttonGroup">
            <div class="r">
              <slot></slot>
              <button class="GreenSmBtn" @click="addclassfy">新增</button>
              <button class="OrangeSmBtn" @click="reset">
                <span>重置</span>
              </button>
              <button class="BlueSmBtn" @click="search">搜索</button>
            </div>
          </div>
        </div>
        <div class="searchForm1">
          <el-form :model="nform" ref="nform">
            <el-form-item prop="stype">
              <el-select v-model="nform.stype">
                <el-option v-for="i of items" :key="i.value" :label="i.label" :value="i.value"></el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
        <div class="tableWrapper" v-loading="!showTable">
          <!-- 后端分页 -->
          <section class="easyTable">
            <el-table :data="tabledata.list" class="stripeTable" stripe style="width: 100%" v-loading="bLoading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading" ref="table_jsgl" height="550">
              <el-table-column v-for="item of config" :key="item.prop" :label="item.label" :prop="item.prop" align="center">
                <template slot-scope="scope">
                  <span v-if="item.prop === 'name'">{{scope.row.name}}</span>
                  <el-select v-model="scope.row.sort" v-else-if="item.prop === 'sort'" @change="getSort(scope.row)">
                    <el-option v-for="i of tabledata.total" :key="i" :label="i" :value="i"></el-option>
                  </el-select>
                  <span v-else-if="item.prop === 'create_time'">{{scope.row.create_time}}</span>
                  <span v-else>{{scope.row.modify_time}}</span>
                </template>
              </el-table-column>
              <el-table-column label="操作" align="center">
                <template slot-scope="scope">
                  <el-link :icon="scope.row.status === 0 ? 'iconfont icontingyong' : 'iconfont iconcheck1'" type="text" size="small" @click="using(scope.row)">{{scope.row.status === 0 ? '停用' : '启用'}}</el-link>
                  <el-link icon="iconfont iconedit" type="text" size="small" @click="row = scope.row; dialogVisible = true; status = 2;nform.atype = scope.row.name">修改</el-link>
                  <el-link icon="iconfont icondel" type="text" size="small" @click="tdelete(scope.row)">删除</el-link>
                </template>
              </el-table-column>
            </el-table>
            <div class="footer">
              <el-pagination layout="prev, pager, next" :total="tabledata.total" @current-change="handleCurrentChange"></el-pagination>
            </div>
          </section>
        </div>
      </el-tab-pane>
    </el-tabs>

    <el-dialog title="新增新闻类型" :visible.sync="dialogVisible" width="30%">
      <el-form :model="nform" ref="nform">
        <el-form-item prop="atype" :rules="[{required:true,message:'请选择新闻类型',trigger:'blur'}]">
          <el-input v-model="nform.atype"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="check">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { dt, obj2urlsp } from 'utils'

export default {
  data() {
    return {
      tabName: 'jsgl',
      showTable: true,
      loading: false,
      dialogVisible: false,
      items: [],
      nform: {
        stype: '',
        atype: '',
      },
      bLoading: true,
      pageNum: 1,
      pageSize: 10,
      tabledata: {},
      status: '',
      row: '',
    }
  },
  computed: {
    self() {
      return this
    },
    config() {
      return [
        {
          prop: 'name',
          label: '分类名称',
        },
        {
          prop: 'sort',
          label: '展示顺序',
        },
        {
          prop: 'create_time',
          label: '创建时间',
        },
        {
          prop: 'modify_time',
          label: '更新时间',
        },
      ]
    },
  },
  methods: {
    reset() {
      this.$refs.nform.resetFields()
    },

    search() {
      this.getData()
    },

    addclassfy() {
      this.status = 1
      this.nform.atype = ''
      this.$nextTick(() => {
        this.dialogVisible = true
        this.$refs.nform.clearValidate()
      })
    },

    add() {
      this.$refs.nform.validate((valid) => {
        if (valid) {
          this.$axiospost('operation/newsTypeApi/addNewsType', {
            name: this.nform.atype,
          }).then((res) => {
            this.$message.success('添加成功')
            this.$nextTick(() => {
              this.$refs.nform.resetFields()
              this.dialogVisible = false
            })
            this.getData()
          })
        }
      })
    },

    handleCurrentChange(value) {
      this.pageNum = value
      this.getData()
    },

    getData() {
      this.$axiosget('operation/newsTypeApi/findNewsTypePage', {
        params: {
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          name: this.nform.stype,
        },
      }).then((res) => {
        this.tabledata = res.data.data
        this.bLoading = false
      })
    },

    initNewsType() {
      this.$axiosget('operation/newsTypeApi/findNewsTypeList').then((res) => {
        let r = res.data.data
        for (let i = 0; i < r.length; i++) {
          let obj = {
            label: r[i].name,
            value: r[i].name,
          }
          this.items.push(obj)
        }
      })
    },

    getSort(row) {
      var formData = new FormData()
      formData.append('sort', row.sort)
      this.$axiospost(`operation/newsTypeApi/updateNewsTypeSort/${row.id}`, formData).then((res) => {
        this.getData()
      })
    },

    using(row) {
      this.$confirm(row.status ? '启用？' : '停用？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'info',
      }).then((res) => {
        let formdata = new FormData()
        formdata.append('id', row.id)
        formdata.append('status', row.status ? 0 : 1)
        // let obj = {
        //   id: row.id,
        //   status: row.status ? 0 : 1
        // };
        this.$axiospost(`operation/newsTypeApi/updateNewsTypeStatus/${row.id}`, formdata).then((res) => {
          this.$message.success('操作成功')
          this.getData()
        })
      })
    },
    edit() {
      this.dialogVisible = true
      this.$axiospost('/operation/newsTypeApi/updateNewsType', {
        id: this.row.id,
        name: this.nform.atype,
      }).then((res) => {
        this.$message.success('修改成功')
        this.$nextTick(() => {
          this.$refs.nform.resetFields()
          this.dialogVisible = false
        })
        this.getData()
      })
    },
    tdelete(row) {
      let formdata = new FormData()
      formdata.append('id', row.id)
      this.$confirm('删除词条新闻类型吗？', '警示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.$axiospost(`operation/newsTypeApi/deleteNewsType/${row.id}`, formdata).then((res) => {
            this.$message.success('删除成功')
            this.getData()
          })
        })
        .catch(() => {})
    },

    check() {
      switch (this.status) {
        case 1:
          this.add()
          break
        case 2:
          this.edit()
          break
      }
    },
  },
  components: {
    normalNav: () => import('public/normalNav'),
    searchForm: () => import('public/searchForm'),
    easyTable: () => import('public/easyTable'),
  },
  mounted() {},
  created() {
    this.getData()
    this.initNewsType()
  },
}
</script>

<style scoped lang="less">
// .content /deep/ .el-dialog{
//   width: 30% !important;
// }
/deep/ .el-dialog .el-input input {
  border-color: rgba(255, 255, 255, 0.2);
}

/deep/ .el-dialog .el-form .el-form-item__content {
  width: 100%;
}
.tableWrapper .easyTable /deep/ .el-table tbody td .el-select .el-input__inner {
  background-color: transparent;
  border-color: rgba(255, 255, 255, 0.2);
  color: #f5f5f5;
  font-size: 12px;
}
.tableWrapper .easyTable /deep/ .el-table tbody td .el-button {
  border: none;
}
</style>
<style>
.el-select-dropdown {
  background-color: #2e3657;
  border: none;
}

.el-select-dropdown .el-select-dropdown__item {
  color: #3587c7;
}

.el-select-dropdown__item.hover,
.el-select-dropdown__item:hover {
  background-color: #262d4a !important;
}

.popper__arrow,
.popper__arrow::after {
  border-bottom-color: #2e3657 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/dynamicRoute3/management/studyonline/subject/classification.vue